"use client";

import { useExecuteAiPrompt } from "../../hooks/useExecuteAiPrompt";
import { useCopilotToolMessageListener } from "../../hooks/useCopilotToolMessageListener";

// CanvasCopilotHydrator needs to be a parent of useExecuteAiPrompt hook so please render
// this component as a child of CanvasCopilotHydrator.
export function ExecuteAiPrompt({ prompt }: { prompt: string }) {
  useExecuteAiPrompt(prompt);
  // Listen for postMessage events from copilot tool components
  useCopilotToolMessageListener();

  return null;
}
